/**
 * @file paddle pilot anchor
 * @author wanzhongyun
 */

import classNames from 'classnames';
import React, { useEffect, useMemo, useRef, useState } from 'react';

import './style.less';


const PilotAnchor: React.FC = () => {
    const anchorList = useMemo(() => {
        return [
            {
                label : '专属权益',
                id: 'personalRights'
            },
            {
                label : '成长资源',
                id: 'growthResource'
            },
            {
                label : '最新动态',
                id: 'startSailing'
            },
            {
                label : '领航团长',
                id: 'groupShow'
            }
        ];
    }, []);
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const [status, setStatus] = useState<boolean>(false);
    const handleAnchorClick = (index: number) => {
        setStatus(true);
        setCurrentIndex(index);
    };

    const currentStatus = useRef<boolean>(status);
    currentStatus.current = status;

    useEffect(() => {
        if (!status) {
            return;
        }
        const anchorID = anchorList[currentIndex];
        const anchorDom = document.querySelector(`#${anchorID.id}`);
        if (anchorID && anchorDom) {
            anchorDom.scrollIntoView({
                block: 'start',
                behavior: 'smooth'
            });
            setTimeout(() => setStatus(false), 2500);
        }
    }, [currentIndex, anchorList, status]);

    useEffect(() => {
        const rightsDom = document.querySelector('.paddle-pilot-rights-title') as HTMLDivElement;
        const backTopDom = document.querySelector('.paddle-pilot-qr-code-wrapper .ant-back-top') as HTMLDivElement;
        const qrDom = document.querySelector('.paddle-pilot-qr-code-wrapper') as HTMLDivElement;
        const scrollListenr = () => requestAnimationFrame(() => {
            if (rightsDom && backTopDom) {
                if (currentStatus.current) {
                    return;
                }
                const rightsTop = rightsDom.getBoundingClientRect().top;

                // backtop的滚动处理
                if (qrDom && rightsTop < -2130) {
                    qrDom.style.position = 'absolute';
                    qrDom.style.top = 'auto';
                    qrDom.style.bottom = '0';
                } else {
                    qrDom.style.position = 'fixed';
                    qrDom.style.bottom = 'auto';
                    qrDom.style.top = '65%';
                }
                
                // backtop的一个监听
                if (rightsTop > 175) {
                    backTopDom.style.display = 'none';
                }
                else {
                    backTopDom.style.display = 'block';
                }

                // scroll时anchor的监听
                if (rightsTop > -280) {
                    setCurrentIndex(0);
                }else if (-860 < rightsTop && rightsTop < -280) {
                    setCurrentIndex(1);
                }else if (-1560 < rightsTop && rightsTop < -860) {
                    setCurrentIndex(2);
                }else {
                    setCurrentIndex(3);
                }
            }
        });

        window.addEventListener('scroll', scrollListenr, false);
        return () => {
            window.removeEventListener('scroll', scrollListenr);
        }
    }, []);

    return (
        <div className='paddle-pilot-anchor-wrapper'>
            <div className='paddle-pilot-anchor-card-wrapper'>
                {
                    anchorList.map((item, index) => <span className={classNames('paddle-pilot-anchor-item', {'paddle-checked': currentIndex === index})} key={item.id} onClick={() => handleAnchorClick(index)}>
                        { item.label }
                    </span>)
                }
            </div>
        </div>
    );
};

export default PilotAnchor;